import React from 'react';
import { Modal, Button } from 'antd';

const CustomModal = ({ 
  open, 
  onCancel, 
  onOk, 
  title, 
  children, 
  width = 400,
  okText = "Да",
  cancelText = "Нет",
  ...props 
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      title={title}
      width={width}
      style={{ 
        top: '10%',
        transform: 'translateY(-50%)',
      }}
      footer={null}
      centered
      {...props}
        styles={{
            header: {
            textAlign: 'center',
            padding: '2px 24px',
            }
        }}
        >
      <div style={{ 
        textAlign: 'center', 
        marginBottom: 24,
        fontSize: '16px',
        lineHeight: '1.5'
      }}>
        {children}
      </div>
      
      <div style={{ 
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        gap: '12px',
        flexWrap: 'wrap'
      }}>
        <Button 
          onClick={onOk} 
          size="middle"
          style={{ minWidth: 80 }}
        >
          {okText}
        </Button>
         <Button 
          type="primary" 
          onClick={onCancel} 
          size="middle"
          style={{ minWidth: 80 }}
        >
          {cancelText}
        </Button>
      </div>
    </Modal>
  );
};

export default CustomModal;